import { connect } from "react-redux";
import { Box, Image, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";


import {
  updateReportRange,
  updateOrganizationId,
} from "../store/actions/defaultAction";

import Nav from "./sidebar/Nav";
import ReportRangeSelection from "./filterForm/ReportRangeSelection";
import { version } from "../store/constants";

import Logo from '../assets/img/logo-dark.svg'
import OrganizationSelection from "./filterForm/OrganizationSelection";
import UserProfileMenu from "./sidebar/UserProfileMenu";

function Sidebar() {
  const { organizationId } = useSelector((store) => store.defaultReducer);
  
  return (
    <Box
      className="sidebar"
      w="260px"
      backgroundColor="var(--white)"
      borderRight="1px solid #ebebeb"
      position="fixed"
      height="100vh"
      overflow="hidden"
      paddingBottom={0}
      display="flex"
      flexDirection="column"
    >
      <Box
        flex="1"
        overflowY="auto"
      >
        <Box p="15px 15px 0">
          <Image src={Logo} alt="logo" />
        </Box>
        <Box p="0px 15px 0">
          <OrganizationSelection />
        </Box>
        <Box
          p="15px 15px 0"
          pt={0}
          mt={ organizationId.length ? "25px" : "0"}
        >
          <ReportRangeSelection />
          <Box mt="15px">
            {
              organizationId && organizationId.length 
              ? <Nav />
              : null
            }
          </Box>

          <Text p="0 15px 0 0" mt="25px" mb="20px" fontSize="15px" textAlign="center" fontWeight={600} color="var(--black-dry)">Version: {version}</Text>
        </Box>
      </Box>
      <UserProfileMenu />
    </Box>
  );
}

export default connect(null, {
  updateReportRange,
  updateOrganizationId,
})(Sidebar);
